import { Box, Breadcrumb, BreadcrumbItem, BreadcrumbLink, Grid, GridItem } from '@chakra-ui/react'
import MyDiv from './proofDeclarationDetail.style';
import DeclarationProfile from '../components/DeclarationProfile';
import * as routesNames from '../../../constants/routes'
import {  NewProofTaxRegime} from '../components';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import OldProofTaxRegime from '../components/OldProofTaxRegime';

const ProofDeclarationDetail = () => {
    const location = useLocation();
    const { employee } = location.state || {};

  return (
    <MyDiv>
      <Breadcrumb spacing='5px' className="font_poppins text_md text_medium" separator=">>">
        <BreadcrumbItem>
          <BreadcrumbLink className="font_poppins text_md text_medium" color="gray.500" href={routesNames.PROOFOFINVESTMENT}>Proof of Investment</BreadcrumbLink>
        </BreadcrumbItem>
        <BreadcrumbItem isCurrentPage>
          <BreadcrumbLink className="font_poppins text_md text_medium" href="#">Employee Tax Declaration Details</BreadcrumbLink>
        </BreadcrumbItem>
      </Breadcrumb>
      <Grid className='grid_container'>
        <GridItem colSpan={4}>
          <Box  className='tab-list-container' mt={4}>
            <DeclarationProfile />
          </Box>
        </GridItem>
        <GridItem colSpan={8} pl={4} >  
          {employee.taxRegime === 'Old Tax Regime' ?             

           <OldProofTaxRegime />
           :
           <NewProofTaxRegime /> 
           }
        </GridItem>
      </Grid>
    </MyDiv>
  )
}

export default ProofDeclarationDetail;
